import { render } from "./SubvPopup.vue?vue&type=template&id=212db053&scoped=true"
import script from "./SubvPopup.vue?vue&type=script&lang=js"
export * from "./SubvPopup.vue?vue&type=script&lang=js"

import "./SubvPopup.vue?vue&type=style&index=0&id=212db053&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212db053"]])

export default __exports__